'use client'

import PlusIcon from '@/components/icons/PlusIcon'
import Card from '@/components/ui/Card'
import ContentWrapper from '@/components/ui/ContentWrapper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

const HomeAboutKommers = () => {
  const t = useTranslations('aboutKommers')
  return (
    <ContentWrapper tag="section" className="relative mt-32 gap-x-8 gap-y-12 lg:gap-8">
      <div className="absolute w-screen -mx-8 lg:hidden flex -top-24 h-[calc(100%+360px)] overflow-hidden -z-1">
        <Image src="/images/backgrounds/globe.png" width={2000} height={1884} alt="transparent globe" className="opacity-5 select-none max-w-none -translate-x-1/3  " />
      </div>
      <article className="row-start-1 col-span-full lg:col-span-6">
        <Card className="overflow-hidden relative border border-accent">
          <div className="absolute top-0 left-0 w-full h-full bg-orange-gradient z-10" />
          <Image className=" absolute top-0 left-0 w-full h-full object-cover" src="/images/backgrounds/Flower-BG-03.jpg" width={4096} height={2304} alt="black flower on the dark backgroud" />
          <article className="z-20 p-12 lg:p-16">
            <h2 className="text-white font-medium text-2xl leading-8 lg:text-[35px] lg:leading-6 ">{t('title')}</h2>
            <p className="font-light text-lg leading-6 mt-12 lg:mt-16">
              {t('description')} <br />
              <br /> {t('text')}
            </p>

            <a href="https://calendly.com/kommers/meet" target="_blank" rel="noopener noreferrer">
              <Card className="bg-white p-8 mt-12 lg:mt-16 w-full lg:w-1/2">
                <PlusIcon size={20} className="text-accent" />
                <p className="font-medium text-KMRS-Darkmode mt-8 leading-6 text-lg">{t('requestProject')}</p>
              </Card>
            </a>
          </article>
        </Card>
      </article>
      <div className="flex flex-col col-span-2 lg:col-span-3">
        <Card className="min-h-48 lg:min-h-96 overflow-hidden rounded-2xl grow border border-accent">
          <Image width={1000} height={1000} className="w-full h-full object-cover" src="/images/employee/kommers-nicolas.jpg" alt="Nicolas Bettag | KOMMERS" />
        </Card>
        <div className="mt-8">
          <PlusIcon size={20} className="text-accent w-5 h-5 object-cover" />
          <p className="mt-8 text-white leading-6 text-lg font-light">
            <strong className="font-medium">Nicolas Bettag</strong>
            <br />
            {t('founder')}
            <br />
            <a className="text-accent lg:hidden" href="mailto:nicolas.bettag@kommers.io">
              {t('email')}
            </a>
            <a href="mailto:nicolas.bettag@kommers.io" className="hidden lg:block">
              nicolas.bettag@kommers.io
            </a>
          </p>
        </div>
      </div>
      <div className="flex flex-col col-span-2 lg:col-span-3">
        <Card className="min-h-48 lg:min-h-96 overflow-hidden rounded-2xl grow border border-accent">
          <Image width={1000} height={1000} className="w-full h-full object-cover" src="/images/employee/kommers-max.jpg" alt="Max Spechtler | KOMMERS" />
        </Card>
        <div className="mt-8">
          <PlusIcon size={20} className="text-accent w-5 h-5 object-cover" />
          <p className="mt-8 text-white leading-6 text-lg font-light">
            <strong className="font-medium">Max Spechtler</strong>
            <br />
            {t('creativeDirector')}
            <br />
            <a className="text-accent lg:hidden" href="mailto:max.spechtler@kommers.io">
              {t('email')}
            </a>
            <a href="mailto:max.spechtler@kommers.io" className="hidden lg:block">
              max.spechtler@kommers.io
            </a>
          </p>
        </div>
      </div>
    </ContentWrapper>
  )
}

export default HomeAboutKommers
